import { getTinkoffPaymentInfo } from './createTinkoffPaymentLink';

/**
 * Статус платежа. После удаления ЮKassa с сайта провайдер один — Т-Касса,
 * но имя функции сохранено, чтобы не трогать импорты на страницах оплаты.
 */
export const getPaymentStatusAny = async (paymentId: string): Promise<any> => {
  return await getTinkoffPaymentInfo(paymentId);
};
